import { IdentityUserView } from 'api';
import { useContext } from 'react';
import { LoginForExistingUser } from 'pages/profile/components/LoginForExistingUser';
import { BookingFormContext } from 'pages/profile/context2';
import useApplicationSettings from 'hooks/useApplicationSettings';
import { useTranslation } from 'react-i18next';

type Props = {
  onSubmitSuccess: () => void;
  onPrevBtnCick: () => void;
};

export const UserForm = ({ onSubmitSuccess, onPrevBtnCick }: Props) => {
  const { setState } = useContext(BookingFormContext);
  const { t } = useTranslation();
  const { appSettings } = useApplicationSettings();
  const { useCognitoOtpLogin } = appSettings;

  const handleLoginSuccess = async (data: IdentityUserView): Promise<void> => {
    setState((draft) => {
      draft.customerInfo.customerCompany = data.company?.companyName || '';
      draft.customerInfo.customerEmail = data.email || '';
      draft.customerInfo.customerName = data.fullName || '';
      draft.customerInfo.customerPhoneNumber = data.phoneNumber || '';
      draft.customerInfo.isWisoryUser = true;
    });

    onSubmitSuccess();
  };

  return (
    <>
      <LoginForExistingUser
        title={t('REACT_BOOKING_FRONTEND.booking2.loginTitle')}
        useCognitoOtpLogin={!!useCognitoOtpLogin}
        onGoBack={onPrevBtnCick}
        onLoginSuccess={handleLoginSuccess}
      >
        {() => {
          return <></>;
        }}
      </LoginForExistingUser>
    </>
  );
};
